﻿export default class TreeViewControl {

    constructor(ctrlSelector, dataURL, defaultValue, enabled, onlyLeafSelection, onchangeTrigger) {
 
        if (ctrlSelector == null || ctrlSelector == "" || $(ctrlSelector).length == 0) {
            return;
        }
        this.controlSelector = ctrlSelector;
        this.dataURL = dataURL;
        this.defaultValue = defaultValue;
        this.onchangeTrigger = onchangeTrigger;
        this.enabled = enabled;
        this.onlyLeafSelection = onlyLeafSelection == null ? false : onlyLeafSelection;
        this.TemplateId = null;
        this.onSelectTrigger = null;
        this.onDblClickTrigger = null;
        //$(ctrlSelector)[0].innerHTML="<div> Test</div>"
        //https://www.javascripttutorial.net/es6/
        //this.initControl();
    }
    initControl() {

        var trv = $(this.controlSelector).kendoTreeView({
            loadOnDemand: true,
            dataSource: this.getTreeDataSource(null, this.defaultValue),
            dragAndDrop: true,
            dataTextField: "Text",
            //select: trv_select,
            //change: trv_change,
            //collapse: trv_colapse,
            expand: (e) => {
                //debugger;

                //var item = e.sender.dataItem(e.node);
                //if (item.loadedFromDb) {
                //    //nothing to do
                //}
                //else {
                //    item.items = this.getData(this.currentFilter, null, item.Id);
                //    item.loadedFromDb = true;
                //}

            },
            select: (e) => {
                var item = e.sender.dataItem(e.node);
                if (this.onSelectTrigger != null) {
                    this.onSelectTrigger(item);
                }
            },
            template: this.TemplateId != null ? kendo.template($("#" + this.TemplateId).html()) : null,
            dragstart: function (e) {
                if (this.dataSource != null && this.dataSource.filter() != null) {
                    e.preventDefault();
                }

            },
            drop: function (e) {
                //var nodeDataItem = $("#ctrlRuleTree").data("kendoTreeView").dataItem(e.sourceNode);
                //var destinationDataItem = $("#ctrlRuleTree").data("kendoTreeView").dataItem(e.destinationNode);

                //if (nodeDataItem == null || destinationDataItem == null) {
                //    e.setValid(false);
                //    return;
                //}

                //var nodeIsRule = nodeDataItem.$type == typeNameRule;
                //var destinationNodeIsRule = destinationDataItem.$type == typeNameRule;

                //switch (e.dropPosition) {
                //    case "before":
                //    case "after":
                //        if (nodeIsRule != destinationNodeIsRule) {
                //            e.setValid(false);
                //        }
                //        return;
                //    case "over":

                //        if (nodeIsRule || !destinationNodeIsRule) {
                //            e.setValid(false);
                //        }
                //        return;
                //}
            }
        }).data("kendoTreeView");
        //debugger;
        //trv.items().each(function (i, el) {

        //    $(el).on("dblclick", function (event) {
        //        debugger;
        //        var trv = $(event.target).closest(".k-treeview").data("kendoTreeView");
        //        var item = trv.dataItem(this);

        //    });
        //});

        //trv.items().each((function (i, el) {
        //    $(el).on("dblclick", (function (event) {
        //        debugger;
        //        var trv = $(event.target).closest(".k-treeview").data("kendoTreeView");
        //        var item = trv.dataItem($(event.target).closest(".k-mid"));
        //        if (this.onDblClickTrigger != null) {
        //            this.onDblClickTrigger(item);
        //        }
        //    }).bind(this));
        //}).bind(this));

        this.TreeView = trv;
        this.applyDblClick(trv.items());
        //selectNode(null);
    }
    applyDblClick(items) {
        items.each((function (i, el) {
            $(el).on("dblclick", (function (event) {
                var trv = this.TreeView;
                var item = trv.dataItem($(event.target).closest(".k-item"));
                if (this.onDblClickTrigger != null) {
                    this.onDblClickTrigger(item);
                }
            }).bind(this));
        }).bind(this));
    }
    filterDataSource(filterText) {

        var trv = $(this.controlSelector).data("kendoTreeView");
        trv.setDataSource(this.getTreeDataSource(filterText, null));
        this.applyDblClick(trv.items());
    }

    getTreeDataSource(searchText, selectedValue) {

        this.currentFilter = (searchText == null || searchText.trim().length < 3) ? null : searchText;
        this.initialFilteredDataSource = null;

        return new kendo.data.HierarchicalDataSource(
            {
                transport: {
                    read: (options) => {
                        if (options.data.Id == null) {
                            var data = this.getData(this.currentFilter, selectedValue, null);
                            this.initialFilteredDataSource = data;
                            options.success(this.initialFilteredDataSource);
                        }
                        else {
                            var currentItem = this.getItem(this.initialFilteredDataSource, options.data.Id);
                            if (currentItem != null && currentItem.HasChildren && currentItem.items.length > 0) {
                                options.success(currentItem.items);
                                return;
                            }
                            options.success(this.getData(null, null, options.data.Id));
                            this.applyDblClick(this.TreeView.items());
                        }
                    }
                },
                schema: {
                    model: {
                        id: "Id",
                        hasChildren: "HasChildren"
                    }
                }
            });

    }
    getData(searchText, selectedValue, nodeId) {

        var result = [];
        this.nodeId = null;

        var url = this.dataURL;
        if (selectedValue) {
            url += "&selectedTreeNodeId=" + selectedValue.toString();
        }
        else if (searchText != null && searchText.length > 3) {
            url += "&searchText=" + searchText;
        }
        else if (nodeId != null) {
            url += "&Id=" + nodeId;
            this.nodeId = nodeId;
        }

        $.ajax({
            url: url,
            dataType: "json",
            async: false,
            success: (_result) => {
               
                if (_result == null || _result.length == 0) {
                    result = [];
                }
                else {
                    result = this.processTable(_result);
                }
            },
            error: (result) => {
                result = [];
                console.log(result);
            }
        });

        return result;
    }
    processTable(data) {
        var hash = {};
        for (var i = 0; i < data.length; i++) {
            var item = data[i];
            item.expanded = false;

            var id = item["Id"];
            var parentId = item["IdParent"];

            hash[id] = hash[id] || [];
            hash[parentId] = hash[parentId] || [];

            item.items = hash[id];
            item.expanded = item.items != null && item.items.length > 0;
            hash[parentId].push(item);
        }

        var result = hash[this.nodeId == null ? 0 : this.nodeId];

        this.setExpand(result);
        return result;
    }

    setExpand(data) {
        if (data == null) {
            return;
        }
        if (!Array.isArray(data)) {
            data.expanded = data.items != null && data.items.length > 0;
            if (data.expanded) {
                this.setExpand(data.items);
            }
        }
        else {
            for (var i = 0; i < data.length; i++) {
                this.setExpand(data[i]);
            }
        }
    }

    getItem(data, id) {

        if (!Array.isArray(data)) {
            if (data.Id == id) {
                return data;
            }
            if (data.items != null) {
                for (var i = 0; i < data.items.length; i++) {
                    var _item = this.getItem(data.items[i], id);
                    if (_item != null) {
                        return _item;
                    }
                }
            }
        }
        else {
            for (var i = 0; i < data.length; i++) {
                var _item = this.getItem(data[i], id);
                if (_item != null) {
                    return _item;
                }
            }
        }

        return null;
    }

    highlightText(text, searchedText) {

        var result = text;
        var _text = this.removeDiacritics(text.toLowerCase());
        var _searchedText = this.removeDiacritics(searchedText.toLowerCase().trim());

        var occurences = _text.split(_searchedText).map(function (culm) {
            return this.pos += culm.length + _searchedText.length
        }, { pos: -_searchedText.length }).slice(0, -1);
        occurences = occurences.reverse();

        for (var i = 0; i < occurences.length; i++) {
            var str = text.substring(occurences[i], occurences[i] + _searchedText.length);
            var classes = 'highlight_filter';
            if (occurences[i] > 0 && text[occurences[i] - 1] == " ") {
                classes += ' ml-1';
            }
            if ((occurences[i] + str.length) < text.length && text[occurences[i] + str.length] == " ") {
                classes += ' mr-1';
            }
            result = result.substr(0, occurences[i]) + ("<span class='" + classes + "'>" + str + "</span>")
                + result.substr(occurences[i] + str.length);
        }

        return result;
    }

    removeDiacritics(value) {
        var diacriticsMap = {
            'ã': 'a',
            'à': 'a',
            'â': 'a',
            'ă': 'a',
            'é': 'e',
            'è': 'e',
            'ê': 'e',
            'ì': 'i',
            'î': 'i',
            'ò': 'o',
            'ô': 'o',
            'ş': 's',
            'ș': 's',
            'ţ': 't',
            'ț': 't',
            'ù': 'u',
            'û': 'u',
            'ÿ': 'y',
        };
        var diacriticsRegExp = new RegExp(Object.keys(diacriticsMap).join("|"), "ig");
        return value.replace(diacriticsRegExp, function (match) {
            return diacriticsMap[match] || match;
        });
    };
}